import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormaPago } from '@p-p-portafolio/interfaces/formaPago';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormaPagoService {

  private baseUrl = environment.apiBaseUrl + 'api/formapago';
  private newBackBaseUrl = environment.apiNewBackBaseUrl;
  private user = localStorage.getItem('user')
    ? localStorage.getItem('user')
    : 'Invitado';

  constructor(private http: HttpClient) { }

  form: UntypedFormGroup = new UntypedFormGroup({
    clave: new UntypedFormControl(null, [Validators.required]),
    descripcion: new UntypedFormControl('', [Validators.maxLength(40)]),
    pedir_Referencia: new UntypedFormControl(null),
    efectivo: new UntypedFormControl(null),
    pedir_Autorizacion: new UntypedFormControl(null)
  });

  initializeFormGroup() {
    this.form.setValue({
      clave: null,
      descripcion: '',
      pedir_Referencia: null,
      efectivo: null,
      pedir_Autorizacion: null
    });
  }

  populateForm(entity: FormaPago) {
    this.form.setValue(entity);
  }

  getAll(){
    const payload = {
      que: 4,
      tope: '9999',
      clave: '',
      descripcion: '',
      pedir_Referencia: 0,
      iEfectivo: 0,
      pedir_Autorizacion: 0
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}FormPago/cjspa_FormPagoList`;
    return this.http.post<{success: boolean, data: FormaPago[]}>(url, payload, httpOptions);
  }

  getById(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<FormaPago>(url);
  }

  add(entity: FormaPago) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    const url = `${this.baseUrl}/add`;
    return this.http.post<EntityOperationResult>(url + '/' + this.user, entity, httpOptions);
  }

  saveFormaPago(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}FormPago/cjspa_FormPagoAdd`;
    return this.http.post<EntityOperationResult>(
      url,
      payload,
      httpOptions
    );
  }

  updateFormaPago(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}FormPago/cjspa_FormPagoUpd`;
    return this.http.post<EntityOperationResult>(
      url,
      payload,
      httpOptions
    );
  }

  update(entity: FormaPago) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };



    const url = `${this.baseUrl}/upd`;
    return this.http.put<EntityOperationResult>(url + '/' + this.user, entity, httpOptions);
  }

  delete(entity: FormaPago) {
    const url = `${this.baseUrl}/del`;
    return this.http.request<EntityOperationResult>('delete', url + '/' + this.user, { body: entity });
  }
}
